const PREFIX = 'REPORTS_';

export const FETCH_REPORT_DETAILS_REQUEST = `${PREFIX}FETCH_REPORT_DETAILS_REQUEST`;
export const FETCH_REPORT_DETAILS_SUCCESS = `${PREFIX}FETCH_REPORT_DETAILS_SUCCESS`;
export const FETCH_REPORT_DETAILS_ERROR = `${PREFIX}FETCH_REPORT_DETAILS_ERROR`;
